import { StatusIcon, StatusType } from "@/components/wb-ui/status-icon"
import {
  BACKGROUND_CHECK_SIGNALS,
  type CharacterBreakdown,
  dataByBackgroundCheckSignal,
} from "@/constants/company/background-check"
import type { Signal } from "@/constants/signal/signal"
import { cn } from "@/lib/utils"

function BackgroundCheckItem({
  signal,
  breakdown,
}: {
  signal: Signal
  breakdown: CharacterBreakdown
}) {
  const config = dataByBackgroundCheckSignal[signal]
  if (!config) return null

  const status = config.getStatus(breakdown)
  const headline = config.getHeadline(breakdown)
  const description = config.getDescription(breakdown)

  return (
    <div className="flex gap-4 py-4">
      <StatusIcon status={status} />
      <div>
        <h4
          className={cn("wb-h6", {
            "text-muted-foreground": status === StatusType.NO_DATA,
          })}
        >
          {headline}
        </h4>
        {description && <p className="wb-label-muted mt-1">{description}</p>}
      </div>
    </div>
  )
}

export function BackgroundCheckSection({
  characterBreakdown,
}: {
  characterBreakdown: CharacterBreakdown
}) {
  const breakdown = characterBreakdown

  return (
    <div className="divide-border divide-y">
      {BACKGROUND_CHECK_SIGNALS.map((signal) => (
        <BackgroundCheckItem
          key={signal}
          signal={signal}
          breakdown={breakdown}
        />
      ))}
    </div>
  )
}
